/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import DrillAnswerSheetVo from '../../drill/model/DrillAnswerSheetVo';
import PagingDrillVo from '../../drill/model/PagingDrillVo';
import RefAndDisplayedTextVo from '../../drill/model/RefAndDisplayedTextVo';
import UpdatedVo from '../../drill/model/UpdatedVo';
  /**
   * Drill service.
   * @module drill/api/DrillApi
   * @version 0.2.0
   */

  /**
   * Constructs a new DrillApi. 
   * @alias module:drill/api/DrillApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 分页查找题目
     * @param {Integer} pageNum 页码
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sectionId 云教材小节id
     * @param {Integer} opts.courseStandardId 课程标准id，必填
     * @param {Integer} opts.knowledgeId 课程目标知识点id
     * @param {Integer} opts.drillType 题型
     * @param {Integer} opts.companyId 上传院校id
     * @param {Integer} opts.accountId 上传者id
     * @param {String} opts.text 检索词 选填
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/PagingDrillVo}
     */
this.findPage = function(pageNum, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling findPage";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum,
        'sectionId': opts['sectionId'],
        'courseStandardId': opts['courseStandardId'],
        'knowledgeId': opts['knowledgeId'],
        'drillType': opts['drillType'],
        'companyId': opts['companyId'],
        'accountId': opts['accountId'],
        'text': opts['text']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingDrillVo;
      return this.apiClient.callApi(
        '/api/drill/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 取答题卡
     * @param {Integer} sectionId section id
     * @param {Boolean} isNewSession 是否创建新会话
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/DrillAnswerSheetVo}
     */
this.getSectionTest = function(sectionId, isNewSession) {
      var postBody = null;

      // verify the required parameter 'sectionId' is set
      if (sectionId == undefined || sectionId == null) {
        throw "Missing the required parameter 'sectionId' when calling getSectionTest";
      }

      // verify the required parameter 'isNewSession' is set
      if (isNewSession == undefined || isNewSession == null) {
        throw "Missing the required parameter 'isNewSession' when calling getSectionTest";
      }


      var pathParams = {
      };
      var queryParams = {
        'sectionId': sectionId,
        'isNewSession': isNewSession
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = DrillAnswerSheetVo;
      return this.apiClient.callApi(
        '/api/drill/section_test/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 标记题目知识点
     * @param {Integer} id drill id
     * @param {Integer} courseStandardId 课程标准id，必填
     * @param {Integer} knowledgeId 知识点id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/UpdatedVo}
     */
this.markKnowledge = function(id, courseStandardId, knowledgeId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling markKnowledge";
      }

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling markKnowledge";
      }

      // verify the required parameter 'knowledgeId' is set
      if (knowledgeId == undefined || knowledgeId == null) {
        throw "Missing the required parameter 'knowledgeId' when calling markKnowledge";
      }


      var pathParams = {
      };
      var queryParams = {
        'id': id,
        'courseStandardId': courseStandardId,
        'knowledgeId': knowledgeId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/drill/mark_knowledge', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 解析标注文本
     * @param {String} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/RefAndDisplayedTextVo}
     */
this.parseMarkedText = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling parseMarkedText";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = RefAndDisplayedTextVo;
      return this.apiClient.callApi(
        '/api/drill/parse_marked_text', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 标记题目知识点
     * @param {Integer} id drill id
     * @param {Integer} sectionId 云教材小节id
     * @param {Integer} sortKey 序号
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/UpdatedVo}
     */
this.sortSectionDrill = function(id, sectionId, sortKey) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling sortSectionDrill";
      }

      // verify the required parameter 'sectionId' is set
      if (sectionId == undefined || sectionId == null) {
        throw "Missing the required parameter 'sectionId' when calling sortSectionDrill";
      }

      // verify the required parameter 'sortKey' is set
      if (sortKey == undefined || sortKey == null) {
        throw "Missing the required parameter 'sortKey' when calling sortSectionDrill";
      }


      var pathParams = {
      };
      var queryParams = {
        'id': id,
        'sectionId': sectionId,
        'sortKey': sortKey
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/drill/sort_section_drill', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 标记题目知识点
     * @param {Integer} id drill id
     * @param {Integer} courseStandardId 课程标准id，必填
     * @param {Integer} knowledgeId 知识点id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/UpdatedVo}
     */
this.unmarkKnowledge = function(id, courseStandardId, knowledgeId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling unmarkKnowledge";
      }

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling unmarkKnowledge";
      }

      // verify the required parameter 'knowledgeId' is set
      if (knowledgeId == undefined || knowledgeId == null) {
        throw "Missing the required parameter 'knowledgeId' when calling unmarkKnowledge";
      }


      var pathParams = {
      };
      var queryParams = {
        'id': id,
        'courseStandardId': courseStandardId,
        'knowledgeId': knowledgeId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/drill/unmark_knowledge', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
